import { Component, Input, OnInit } from '@angular/core';
import { Request } from '../../types/requests/Request';
import { RequestService } from '../../services/request.service';

@Component({
    selector: 'las-bill-requests-content',
    templateUrl: './bill-requests-content.component.html',
    styleUrls: ['./bill-requests-content.component.scss'],
    standalone: false,
})
export class BillRequestsContentComponent implements OnInit {
    @Input() billId: string = '';

    requests: Request[] = [];
    reqLoaded: boolean = false;

    constructor(private requestService: RequestService) {}

    /**
     * Loads a bill's requests by its id.
     */
    ngOnInit(): void {
        this.requestService
            .getBillRequests(this.billId)
            .subscribe((requests) => {
                this.reqLoaded = true;
                this.requests = requests;
            });
    }
}
